import { navigate, RouteComponentProps } from "@reach/router";
import React from "react";
import { apolloClient } from "data/graphql";
import { wipeToken } from "utils/general-utils";
import { asteroid } from "../data/meteor-server";
import { clearFiltersState, clearPageNumbers } from "./dashboard/interests/utils";

const Logout: React.FC<RouteComponentProps> = () => {
  const logout = () => {
    asteroid
      .logout()
      .finally(() => {
        clearFiltersState();
        clearPageNumbers();
        wipeToken();
        // apolloClient.clearStore();
        apolloClient.resetStore(); // Clear + refetch
        apolloClient.cache.gc();
        navigate("/login");
      });
  };
  React.useEffect(logout, []);

  return null;
};

export default Logout;
